import React from 'react';
import {
    Nav,
    IconProps,
    SpotifyFilled,
    YoutubeFilled,
    FacebookFilled,
    TwitterFilled,
    InstagramFilled,
    TiktokOutlined,
    IconButton,
    Flex,
} from '@landr/maestro';

interface IconLinkProps {
    icon: React.FC<IconProps>;
    href: string;
    label: string;
}

const IconLink: React.FC<IconLinkProps> = ({ href, label, icon }) => {
    return (
        <IconButton
            as={Nav.Link}
            href={href}
            target="_blank"
            icon={icon}
            label={label}
            isRounded
            variant="ghost"
            size="md"
        />
    );
};

const iconLinkList: Array<IconLinkProps> = [
    {
        href: 'https://open.spotify.com/playlist/6R6NG6OhuXubiRCztBrLac',
        label: 'Spotify',
        icon: SpotifyFilled,
    },
    {
        href: 'https://www.youtube.com/LANDRmusic',
        label: 'Youtube',
        icon: YoutubeFilled,
    },
    {
        href: 'https://www.facebook.com/LANDRmusic',
        label: 'Facebook',
        icon: FacebookFilled,
    },
    {
        href: 'https://twitter.com/landr_music',
        label: 'Twitter',
        icon: TwitterFilled,
    },
    {
        href: 'https://www.instagram.com/landrmusic',
        label: 'Instagram',
        icon: InstagramFilled,
    },
    {
        href: 'https://www.tiktok.com/@landrmusic',
        label: 'Tiktok',
        icon: TiktokOutlined,
    },
];

export const SocialNavigation: React.FC = () => {
    return (
        <Nav
            flexDirection={{ base: 'column', md: 'row' }}
            justifyContent={{
                base: 'center',
                md: 'flex-end',
            }}
        >
            <Flex gap="xs" justifyContent="flex-start">
                {iconLinkList.slice(0, 3).map((props) => (
                    <IconLink key={props.label} {...props} />
                ))}
            </Flex>
            <Flex gap="xs">
                {iconLinkList.slice(3).map((props) => (
                    <IconLink key={props.label} {...props} />
                ))}
            </Flex>
        </Nav>
    );
};
